"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snapToMarks = snapToMarks;

var _d3Array = require("d3-array");

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project

/**
 * Use in slider, given a number and an array of numbers, return the nears number from the array
 * @param value
 * @param marks
 */
function snapToMarks(value, marks) {
  // always use bin x0
  var i = (0, _d3Array.bisectLeft)(marks, value);

  if (i === 0) {
    return marks[i];
  } else if (i === marks.length) {
    return marks[i - 1];
  }

  var idx = marks[i] - value < value - marks[i - 1] ? i : i - 1;
  return marks[idx];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9wbG90LnRzIl0sIm5hbWVzIjpbInNuYXBUb01hcmtzIiwidmFsdWUiLCJtYXJrcyIsImkiLCJsZW5ndGgiLCJpZHgiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFHQTs7QUFIQTtBQUNBOztBQUlBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDTyxTQUFTQSxXQUFULENBQXFCQyxLQUFyQixFQUFvQ0MsS0FBcEMsRUFBNkQ7QUFDbEU7QUFDQSxNQUFNQyxDQUFDLEdBQUcseUJBQVdELEtBQVgsRUFBa0JELEtBQWxCLENBQVY7O0FBQ0EsTUFBSUUsQ0FBQyxLQUFLLENBQVYsRUFBYTtBQUNYLFdBQU9ELEtBQUssQ0FBQ0MsQ0FBRCxDQUFaO0FBQ0QsR0FGRCxNQUVPLElBQUlBLENBQUMsS0FBS0QsS0FBSyxDQUFDRSxNQUFoQixFQUF3QjtBQUM3QixXQUFPRixLQUFLLENBQUNDLENBQUMsR0FBRyxDQUFMLENBQVo7QUFDRDs7QUFDRCxNQUFNRSxHQUFHLEdBQUdILEtBQUssQ0FBQ0MsQ0FBRCxDQUFMLEdBQVdGLEtBQVgsR0FBbUJBLEtBQUssR0FBR0MsS0FBSyxDQUFDQyxDQUFDLEdBQUcsQ0FBTCxDQUFoQyxHQUEwQ0EsQ0FBMUMsR0FBOENBLENBQUMsR0FBRyxDQUE5RDtBQUNBLFNBQU9ELEtBQUssQ0FBQ0csR0FBRCxDQUFaO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTUERYLUxpY2Vuc2UtSWRlbnRpZmllcjogTUlUXG4vLyBDb3B5cmlnaHQgY29udHJpYnV0b3JzIHRvIHRoZSBrZXBsZXIuZ2wgcHJvamVjdFxuXG5pbXBvcnQge2Jpc2VjdExlZnR9IGZyb20gJ2QzLWFycmF5JztcblxuLyoqXG4gKiBVc2UgaW4gc2xpZGVyLCBnaXZlbiBhIG51bWJlciBhbmQgYW4gYXJyYXkgb2YgbnVtYmVycywgcmV0dXJuIHRoZSBuZWFycyBudW1iZXIgZnJvbSB0aGUgYXJyYXlcbiAqIEBwYXJhbSB2YWx1ZVxuICogQHBhcmFtIG1hcmtzXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBzbmFwVG9NYXJrcyh2YWx1ZTogbnVtYmVyLCBtYXJrczogbnVtYmVyW10pOiBudW1iZXIge1xuICAvLyBhbHdheXMgdXNlIGJpbiB4MFxuICBjb25zdCBpID0gYmlzZWN0TGVmdChtYXJrcywgdmFsdWUpO1xuICBpZiAoaSA9PT0gMCkge1xuICAgIHJldHVybiBtYXJrc1tpXTtcbiAgfSBlbHNlIGlmIChpID09PSBtYXJrcy5sZW5ndGgpIHtcbiAgICByZXR1cm4gbWFya3NbaSAtIDFdO1xuICB9XG4gIGNvbnN0IGlkeCA9IG1hcmtzW2ldIC0gdmFsdWUgPCB2YWx1ZSAtIG1hcmtzW2kgLSAxXSA/IGkgOiBpIC0gMTtcbiAgcmV0dXJuIG1hcmtzW2lkeF07XG59XG4iXX0=